export default __webpack_public_path__ + "static/media/bgAuth.35a16374.jpg";